// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_mobile_homeContainer__CWLQx"};